module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./UserAddView.js"));
	}, "userAddView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=userAddView!./src/pages/UserMgmt/UserAdd/UserAddView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=userAddView!./src/pages/UserMgmt/UserAdd/UserAddView.js
// module chunks = 43